var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1011,
    height: 246,
    viewBox: "0 0 1011 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.644 22.4779L555.192 27.4451L555.938 27.813L566.19 32.8735L566.936 33.2415L569.387 28.2743L565.949 26.5773L561.082 24.1749L557.644 22.4779ZM571.966 20.3311L566.732 25.765L561.251 23.0598L562.381 15.6L575.712 0.666016L571.966 20.3311ZM465.304 239.766L464.102 239.173L454.272 234.321L453.071 233.728L451.154 237.612L452.69 238.371C451.68 240.837 452.738 243.7 455.165 244.897C457.591 246.095 460.506 245.193 461.85 242.892L463.387 243.65L465.304 239.766Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.495 27.5949C601.422 38.8533 603.105 53.9829 596.582 67.1993C590.058 80.4158 577.025 88.282 563.267 88.8367C562.457 90.2624 561.51 91.5672 560.45 92.7427C564.16 92.9161 567.854 92.5977 571.437 91.8191L572.498 89.6693L574.837 90.9319C576.274 90.4933 577.686 89.979 579.069 89.3912L578.507 87.7844L580.243 88.8713C588.753 84.9469 596.026 78.1905 600.497 69.1318C604.968 60.0731 605.908 50.1912 603.847 41.0487L601.928 40.3317L603.546 39.8007C603.171 38.3457 602.72 36.9116 602.195 35.5047L599.77 34.4155L600.831 32.2657C599.27 28.9481 597.276 25.8228 594.882 22.9834C594.594 24.5395 594.134 26.085 593.495 27.5949Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M592.711 29.2551C599.873 39.9704 601.274 54.1101 595.16 66.4976C589.046 78.8851 576.97 86.3726 564.108 87.2048C569.018 76.6513 564.945 64.125 554.878 58.4435L564.267 39.4215C574.9 43.9564 587.32 39.571 592.711 29.2551Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M565.615 34.0388L555.362 28.9783L540.338 59.418L540.084 59.9955L551.164 63.3177L565.615 34.0388Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.972 232.904L464.802 237.755L473.582 219.966L464.102 214.407L454.972 232.904Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.244 22.4779L420.696 27.4451L419.951 27.813L409.698 32.8735L408.952 33.2415L406.501 28.2743L409.939 26.5773L414.806 24.1749L418.244 22.4779ZM403.922 20.3311L409.156 25.765L414.637 23.0598L413.507 15.6L400.176 0.666016L403.922 20.3311ZM510.584 239.766L511.786 239.173L521.616 234.321L522.818 233.728L524.735 237.612L523.198 238.371C524.208 240.837 523.15 243.7 520.724 244.897C518.297 246.095 515.382 245.193 514.038 242.892L512.502 243.65L510.584 239.766Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.393 27.5949C374.466 38.8533 372.783 53.9829 379.306 67.1993C385.83 80.4158 398.863 88.282 412.621 88.8367C413.431 90.2624 414.378 91.5672 415.438 92.7427C411.728 92.9161 408.034 92.5977 404.452 91.8191L403.39 89.6693L401.051 90.9319C399.615 90.4933 398.202 89.979 396.819 89.3912L397.381 87.7844L395.645 88.8713C387.135 84.9469 379.862 78.1905 375.391 69.1318C370.92 60.0731 369.98 50.1912 372.041 41.0487L373.96 40.3317L372.342 39.8007C372.717 38.3457 373.168 36.9116 373.693 35.5047L376.118 34.4155L375.057 32.2657C376.618 28.9481 378.612 25.8228 381.006 22.9834C381.294 24.5395 381.754 26.085 382.393 27.5949Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M383.177 29.2551C376.015 39.9704 374.614 54.1101 380.728 66.4976C386.842 78.8851 398.918 86.3726 411.78 87.2048C406.87 76.6513 410.943 64.125 421.01 58.4435L411.621 39.4215C400.989 43.9564 388.568 39.571 383.177 29.2551Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.273 34.0388L420.526 28.9783L435.55 59.418L435.805 59.9955L424.724 63.3177L410.273 34.0388Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M520.916 232.904L511.087 237.755L502.306 219.966L511.786 214.407L520.916 232.904Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.661 48.7961L555.288 68.4844C558.478 69.4413 560.663 72.3776 560.663 75.7071V147.899C560.663 158.033 556.556 168.201 548.803 178.095L546.726 176.467C554.223 166.9 558.023 157.289 558.023 147.899V75.7071C558.023 73.5424 556.604 71.6341 554.531 71.0123L488.903 51.3236C487.984 51.0479 487.004 51.0479 486.086 51.3236L420.457 71.0123C418.384 71.6341 416.963 73.5424 416.963 75.7071V147.899C416.963 157.288 420.765 166.9 428.262 176.467C433.988 183.774 441.909 191.111 451.805 198.275C468.431 210.31 484.802 217.692 485.492 218.001C486.128 218.286 486.812 218.429 487.494 218.429C488.177 218.429 488.86 218.286 489.497 218.001C490.185 217.692 506.557 210.31 523.182 198.275C533.079 191.111 541 183.774 546.726 176.467L548.803 178.095C542.886 185.645 534.767 193.147 524.73 200.413C507.902 212.594 491.355 220.061 490.577 220.409C489.595 220.848 488.545 221.068 487.494 221.068C486.444 221.068 485.392 220.848 484.413 220.409C483.642 220.065 467.09 212.597 450.258 200.413C440.221 193.147 432.102 185.645 426.185 178.095C418.432 168.201 414.325 158.032 414.325 147.899V75.7071C414.325 72.3772 416.509 69.4413 419.698 68.4845L485.327 48.796C486.741 48.3718 488.248 48.3718 489.661 48.7961Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.899 56.6586L423.77 73.7972C421.807 74.3858 420.464 76.1919 420.464 78.2403V146.56C420.464 155.446 424.061 164.543 431.156 173.597C434.63 178.029 438.956 182.473 444.081 186.878L459.827 154.578C450.757 146.81 445.008 135.274 445.008 122.395C445.008 101.201 460.575 83.6427 480.899 80.5296V56.6586ZM457.239 196.909C471.578 206.71 484.717 212.635 485.316 212.903C485.919 213.173 486.566 213.309 487.212 213.309C487.858 213.309 488.505 213.174 489.107 212.903C489.709 212.634 502.96 206.659 517.371 196.781L500.622 162.634C496.451 164.008 491.994 164.751 487.365 164.751C482.728 164.751 478.265 164.006 474.091 162.629L457.239 196.909ZM530.62 186.637L514.897 154.582C523.97 146.815 529.721 135.276 529.721 122.395C529.721 101.109 514.019 83.4905 493.566 80.49V56.6708L550.654 73.7972C552.616 74.3858 553.959 76.1919 553.959 78.2403V146.56C553.959 155.446 550.362 164.543 543.267 173.597C539.857 177.948 535.624 182.312 530.62 186.637Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.397 150.116C513.887 145.29 518.564 138.154 520.219 129.921H511.662C510.308 134.876 507.473 139.22 503.661 142.44L487.248 108.715L470.928 141.979C465.801 137.394 462.574 130.721 462.574 123.294C462.574 109.466 473.76 98.2559 487.56 98.2559C499.07 98.2559 508.763 106.054 511.662 116.666H520.219C517.152 101.404 503.695 89.9106 487.56 89.9106C469.161 89.9106 454.245 104.856 454.245 123.294C454.245 134.025 459.298 143.573 467.149 149.681L447.395 189.945L454.238 195.161L474.061 153.823C478.187 155.657 482.755 156.677 487.56 156.677C492.223 156.677 496.661 155.717 500.69 153.984L520.553 194.86L526.84 190.066L507.397 150.116ZM497.037 146.467L487.248 126.322L477.671 146.294C480.704 147.604 484.047 148.331 487.56 148.331C490.915 148.331 494.115 147.668 497.037 146.467Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0154 156.547C20.2509 156.547 15.9626 155.551 12.1504 153.559C8.3818 151.523 5.41426 148.707 3.24876 145.112C1.08327 141.517 0 137.445 0 132.897C0 128.348 1.08327 124.276 3.24876 120.681C5.41426 117.086 8.3818 114.292 12.1504 112.299C15.9626 110.264 20.2509 109.246 25.0154 109.246C29.1738 109.246 32.921 109.982 36.2561 111.455C39.5911 112.928 42.3637 115.05 44.5729 117.822L36.386 125.229C33.4408 121.677 29.8672 119.902 25.6651 119.902C23.1961 119.902 20.987 120.443 19.0377 121.526C17.1321 122.609 15.6377 124.146 14.5544 126.139C13.5148 128.088 12.995 130.341 12.995 132.897C12.995 135.452 13.5148 137.726 14.5544 139.719C15.6377 141.668 17.1321 143.184 19.0377 144.267C20.987 145.35 23.1961 145.892 25.6651 145.892C29.8672 145.892 33.4408 144.116 36.386 140.564L44.5729 147.971C42.3637 150.743 39.5911 152.865 36.2561 154.338C32.921 155.811 29.1738 156.547 25.0154 156.547ZM97.226 139.329V155.638H84.361V139.134L67.0126 110.155H80.5924L91.3783 128.218L102.164 110.155H114.639L97.226 139.329ZM175.418 131.922C178.017 132.832 180.053 134.261 181.526 136.21C182.999 138.116 183.735 140.434 183.735 143.163C183.735 147.147 182.132 150.224 178.927 152.389C175.722 154.555 171.086 155.638 165.022 155.638H140.462V110.155H163.723C169.527 110.155 173.945 111.239 176.978 113.404C180.01 115.527 181.526 118.407 181.526 122.046C181.526 124.211 180.985 126.16 179.902 127.893C178.862 129.583 177.368 130.926 175.418 131.922ZM153.197 119.447V128.218H162.034C166.366 128.218 168.531 126.745 168.531 123.8C168.531 120.897 166.366 119.447 162.034 119.447H153.197ZM163.983 146.346C168.487 146.346 170.74 144.808 170.74 141.733C170.74 138.658 168.487 137.12 163.983 137.12H153.197V146.346H163.983ZM249.655 145.697V155.638H213.139V110.155H248.811V120.096H225.875V127.764H246.082V137.38H225.875V145.697H249.655ZM299.419 143.552H292.402V155.638H279.537V110.155H300.329C304.444 110.155 308.017 110.849 311.05 112.234C314.081 113.578 316.42 115.527 318.067 118.082C319.713 120.595 320.536 123.561 320.536 126.984C320.536 130.276 319.756 133.156 318.197 135.625C316.68 138.051 314.493 139.957 311.634 141.343L321.446 155.638H307.671L299.419 143.552ZM307.541 126.984C307.541 124.861 306.869 123.215 305.527 122.046C304.184 120.876 302.191 120.291 299.549 120.291H292.402V133.611H299.549C302.191 133.611 304.184 133.048 305.527 131.922C306.869 130.752 307.541 129.107 307.541 126.984ZM680.497 146.801H661.265L657.691 155.638H644.566L664.643 110.155H677.313L697.456 155.638H684.071L680.497 146.801ZM676.729 137.315L670.881 122.76L665.033 137.315H676.729ZM745.886 156.547C741.122 156.547 736.834 155.551 733.021 153.559C729.253 151.523 726.285 148.707 724.12 145.112C721.954 141.517 720.871 137.445 720.871 132.897C720.871 128.348 721.954 124.276 724.12 120.681C726.285 117.086 729.253 114.292 733.021 112.299C736.834 110.264 741.122 109.246 745.886 109.246C750.045 109.246 753.792 109.982 757.127 111.455C760.462 112.928 763.235 115.05 765.444 117.822L757.257 125.229C754.312 121.677 750.738 119.902 746.536 119.902C744.067 119.902 741.858 120.443 739.909 121.526C738.003 122.609 736.509 124.146 735.425 126.139C734.386 128.088 733.866 130.341 733.866 132.897C733.866 135.452 734.386 137.726 735.425 139.719C736.509 141.668 738.003 143.184 739.909 144.267C741.858 145.35 744.067 145.892 746.536 145.892C750.738 145.892 754.312 144.116 757.257 140.564L765.444 147.971C763.235 150.743 760.462 152.865 757.127 154.338C753.792 155.811 750.045 156.547 745.886 156.547ZM803.222 120.356H789.252V110.155H829.992V120.356H816.087V155.638H803.222V120.356ZM857.526 110.155H870.391V155.638H857.526V110.155ZM948.291 110.155L928.798 155.638H916.128L896.7 110.155H910.605L922.951 139.784L935.556 110.155H948.291ZM1010.21 145.697V155.638H973.694V110.155H1009.37V120.096H986.425V127.764H1006.64V137.38H986.425V145.697H1010.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 429.801,
    y1: 57.6641,
    x2: 516.692,
    y2: 220.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 460.678,
    y1: 93.643,
    x2: 501.875,
    y2: 209.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#EE909E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7953D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.484172aef54d7fecd9825cef17105c0a.svg";
export { ForwardRef as ReactComponent };